import { html, TemplateResult } from 'lit';
import { ColumnDetails } from '../../grid/types/common';
import { Column, ColumnKeys } from '../tagsManagerGrid/types';

export function renderTagName(
  dispatchClickEventFn: (tagId: string, tagName: string) => void,
  rowData,
  columnDetails: ColumnDetails<Column, ColumnKeys>
): TemplateResult {
  const tagId = rowData.item[ColumnKeys.TAG_ID];
  const tagName = rowData.item[columnDetails.key];

  return html`<span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(tagId, tagName)}"
  >
    <gz-grid-cell-default-renderer .label="${rowData?.item?.name}"></gz-grid-cell-default-renderer>
  </span>`;
}
